import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactions = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 4,
			height: 8.98241,
			rx: 2,
			transform: "matrix(-1 0 0 1 29.8359 16.0016)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4,
			height: 25.8944,
			rx: 2,
			transform: "matrix(-1 0 0 1 21.9424 8)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 4,
			height: 14.684,
			rx: 2,
			transform: "matrix(-1 0 0 1 14.0107 14)",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgTransactions);
export default ForwardRef;
